import React, { Component } from 'react';
import RootContainer from '../RootContainer';
import './styles.css';

export default class ContentSection extends Component {

  render() {
    return (
      <RootContainer className={`content-section ${this.props.containerClassName || ''}`}>
        <div className={`content-section-container ${this.props.containerClassName || ''}`}>
          <div className={`content-section-content ${this.props.className || ''}`}>
            {this.props.children}
          </div>
        </div>
      </RootContainer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ContentSection/index.js